import React from "react";
import useWorkspaces from "../Hooks/useWorkspaces";
import { Redirect, Route } from "./index";
import { routes } from "./routes";

const ContentCreatorRoute = (props) => {
  const { getPlanConfig } = useWorkspaces();
  return getPlanConfig() && !getPlanConfig()?.isContentCreatorEnabled ? (
    <Redirect
      to={{
        pathname: routes.accessDenied,
      }}
    />
  ) : (
    <Route {...props} />
  );
};

export default ContentCreatorRoute;
